<div class="field">
  <div class="field__body">
    <ng-content></ng-content>
  </div>
  <div class="field__actions">
    <ng-content select="[slot=actions]"></ng-content>
  </div>
</div>
